import React, {Component} from "react";
import {KeyOutlined} from '@ant-design/icons';
import {Form} from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {Button, Col, Input, Row, Tooltip} from "antd";
import {connect} from "react-redux";
import {login} from "../redux_actions/login.action";
import {Link} from "react-router-dom";
import {checkCapsLockOn, checkIfMobile} from '../utils/utils'
import {MorphleLogo} from '../utils/const'
import { clearLoginFailureMessage } from "../redux_actions/login.action";
import '../asset/style/login.css'

class RecoveryTotpLoginForm extends Component {
	constructor(props) {
		super(props);
		this.formRef = React.createRef();
		this.recoveryTotpCodeInputRef = React.createRef();
		this.state = {
			isFetching: false,
			capsLockOn: false,
		};
	}

	watchKeyBoard = (e) => {
		this.setState({capsLockOn: checkCapsLockOn(e, this.state.capsLockOn)})
	}

	componentDidMount = () => {
		let isMobile = checkIfMobile();
		document.documentElement.style.setProperty('--login-div-size', isMobile ? "20em" : "40em");
		this.props.dispatch(clearLoginFailureMessage());
		document.addEventListener('keyup', this.watchKeyBoard);
		this.recoveryTotpCodeInputRef.current.focus();
    }

	componentWillUnmount = () => {
		document.removeEventListener('keyup', this.watchKeyBoard)
	}

	handleSubmit = e => {
		e?.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				this.props.dispatch(login(values));
			}
		});
	};

	getRecoveryTotpPrefix = () => {
		if (this.state.capsLockOn) {
			return <Tooltip title="CapsLock is ON"><KeyOutlined style={{color: "rgba(255, 191, 0, 1)"}}/></Tooltip>
		}
		return <KeyOutlined style={{color: "rgba(0,0,0,.25)"}}/>
	}

	renderForm() {
		const {getFieldDecorator} = this.props.form;

		let content = [];
		content = content.concat([
            <Form.Item style={{display: "none"}}>
				{getFieldDecorator("username", {
					initialValue: this.props.usernameTotp
				})}
			</Form.Item>,
			<Form.Item style={{display: "none"}}>
				{getFieldDecorator("password", {
					initialValue: this.props.passwordTotp
				})}
			</Form.Item>,
			<Form.Item
				extra={this.state.capsLockOn ? <label style={{color: "rgba(255, 191, 0, 1)"}}>CapsLock is On</label> :
					<label style={{color: "rgba(0, 0, 0, 0)"}}>CapsLock is Off</label>}
				>
				{getFieldDecorator("totp_code", {
					rules: [{required: true, message: "Please input your recovery totp!"}]
				})(
					<Input
						prefix={this.getRecoveryTotpPrefix()}
						ref={this.recoveryTotpCodeInputRef} 
						placeholder="XXXXXX"
					/>
				)}
			</Form.Item>,
            <Form.Item style={{display: "none"}}>
                {getFieldDecorator("is_recovery_totp_code", {
                    initialValue: true
                })}
            </Form.Item>,
			<Form.Item style={{display: "none"}}>
				{
					getFieldDecorator("csrfmiddlewaretoken", {
						valuePropName: "Checked",
						initialValue: this.props.csrfToken
					})}
			</Form.Item>
		]);
		if (this.props.isWrongCredential) {
			content.push(<div style={{color: "red"}}>{this.props.loginFailureMessage}</div>);
		}
		content.push(
			<Form.Item>
				<Button
					type="primary"
					htmlType="submit"
					className="login-form-button"
					loading={this.props.isFetching}>
					Verify
				</Button>
			</Form.Item>
		);

		return content;
	}

	renderContent() {

		let content = [];
		content.push(<div className="totp-container">
                        <KeyOutlined style={{ fontSize: '40px' }} />
                          <p className="totp-info unselectable">Recovery code</p>
                     </div>);

		if (this.props.demoLogin) {
			let elems = [
				<p key={0} className="demo-login">For Accessing Demo Scans</p>,
				<p key={1} className="demo-login"><b>username</b> : morphledemo</p>,
				<p key={2} className="demo-login"><b>password</b> : demouser1234</p>
			];
			content = content.concat(elems);
		}

		content.push(
			<Form ref={this.formRef} onSubmit={this.handleSubmit}>
				{this.renderForm()}
			</Form>
		);

        content.push(<p className="totp-info-bottom unselectable">If you are unable to access your mobile device, enter one of your recovery codes to verify your identity.</p>);
        content.push(<p className="totp-info-bottom unselectable" >
						<p><Link to="/totp">Use TOTP code</Link></p>
					</p>);
		return content;
	}

	render() {

		return (
			<Row>
				<Col className="login-form overlayed-component">
					<Link to={'/login'}><img className="login-logo" src={MorphleLogo} alt={"Morphle Logo"}/></Link>
					{this.renderContent()}
				</Col>
			</Row>
		);
	}
}

const WrappedNormalRecoveryTotpLoginForm = Form.create()(RecoveryTotpLoginForm);

const mapStateToProps = state => {
	return state.loginAlerts;
};

export default connect(mapStateToProps)(WrappedNormalRecoveryTotpLoginForm);
